import React from "react";
import { connect } from "react-redux";
import Layout1 from "../layout1";
import Layout2 from "../layout2";

export const UserContext = React.createContext();

const AppRoutes = ({ userLevel, userRoles, tenantInfo }) => {
  const selectedTheme = tenantInfo?.selectedTheme?.toLowerCase();

  let LayoutComponent = Layout1;
  if (selectedTheme === "newlayout") {
    LayoutComponent = Layout2;
  } else if (["round", "rectangular"].includes(selectedTheme)) {
    require(`../../${selectedTheme}.css`);
  }

  return (
    <UserContext.Provider
      value={{
        level: userLevel,
        roles: userRoles,
      }}
    >
      <LayoutComponent />
    </UserContext.Provider>
  );
};

const mapStateToProps = (state) => ({
  userRoles: state.auth.userRoles,
  userLevel: state.auth.userLevel,
  tenantInfo: state.tenant.tenantInfo,
});
export default connect(mapStateToProps, {})(AppRoutes);
